/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { KoreaReturnApplicationOrderVo } from './KoreaReturnApplicationOrderVo';
import {
    KoreaReturnApplicationOrderVoFromJSON,
    KoreaReturnApplicationOrderVoFromJSONTyped,
    KoreaReturnApplicationOrderVoToJSON,
    KoreaReturnApplicationOrderVoToJSONTyped,
} from './KoreaReturnApplicationOrderVo';

/**
 * 
 * @export
 * @interface ResponseListKoreaReturnApplicationOrderVo
 */
export interface ResponseListKoreaReturnApplicationOrderVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListKoreaReturnApplicationOrderVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListKoreaReturnApplicationOrderVo
     */
    message?: string;
    /**
     * 
     * @type {Array<KoreaReturnApplicationOrderVo>}
     * @memberof ResponseListKoreaReturnApplicationOrderVo
     */
    data?: Array<KoreaReturnApplicationOrderVo>;
}

/**
 * Check if a given object implements the ResponseListKoreaReturnApplicationOrderVo interface.
 */
export function instanceOfResponseListKoreaReturnApplicationOrderVo(value: object): value is ResponseListKoreaReturnApplicationOrderVo {
    return true;
}

export function ResponseListKoreaReturnApplicationOrderVoFromJSON(json: any): ResponseListKoreaReturnApplicationOrderVo {
    return ResponseListKoreaReturnApplicationOrderVoFromJSONTyped(json, false);
}

export function ResponseListKoreaReturnApplicationOrderVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListKoreaReturnApplicationOrderVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(KoreaReturnApplicationOrderVoFromJSON)),
    };
}

export function ResponseListKoreaReturnApplicationOrderVoToJSON(json: any): ResponseListKoreaReturnApplicationOrderVo {
    return ResponseListKoreaReturnApplicationOrderVoToJSONTyped(json, false);
}

export function ResponseListKoreaReturnApplicationOrderVoToJSONTyped(value?: ResponseListKoreaReturnApplicationOrderVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(KoreaReturnApplicationOrderVoToJSON)),
    };
}

